/**
 * 🔴 Every figure is nullable and there are NO defaults.
 *
 * Both variants used to declare `buyerPercentage = 75, priceSpread = 8.2,
 * dealSpread = 51, sentiment = 'Greed'`. Those are not neutral fallbacks —
 * they are a plausible, specific, entirely invented market reading, and they
 * rendered whenever the props were undefined: a failed stats call, a gated
 * session, a caller that forgot an argument. Anyone reading the dashboard
 * would have had no way to tell.
 *
 * `null` now means "no reading", and the component says so.
 */
export interface MarketIndicatorBaseProps {
  buyerPercentage?: number | null
  sentiment?: string | null
  priceSpread?: number | null
  dealSpread?: number | null
  loading?: boolean
}

/** What a figure looks like when there is no figure. */
export const NO_READING = '—'

export const formatSpread = (value: number | null | undefined): string =>
  value === null || value === undefined ? NO_READING : Math.abs(value).toFixed(1)

/** Bar width for a spread. Zero-width when unknown — never a default length. */
export const spreadBarWidth = (value: number | null | undefined): number =>
  value === null || value === undefined ? 0 : Math.min(Math.abs(value), 100)
